/**
 * @name results.controller:directiveTableToolbar
 * @description
 * # directiveTableToolbarCtrl
 * Controller for table toolbar directive
 */
export default function directiveTableToolbarCtrl($scope, userPreference) {
    'ngInject';

    const pedigree = userPreference.TYPE_PEDIGREE;
    const comments = userPreference.TYPE_COMMENTS;

    if (!userPreference.isPreferenceSet(comments)) {
        userPreference.set(comments, true);
    }

    /**
     * Returns pedigrees state
     * @return {Boolean}
     */
    $scope.getPedigreesState = () => userPreference.get(pedigree);

    /**
     * Toggles pedigrees
     */
    $scope.togglePedigrees = () => {
        userPreference.toggle(pedigree);
    };

    /**
     * Returns comments state
     * @return {Boolean}
     */
    $scope.getCommentsState = () => userPreference.get(comments);

    /**
     * Toggles comments
     */
    $scope.toggleComments = () => {
        userPreference.toggle(comments);
    };
}



// WEBPACK FOOTER //
// ./src/js/controllers/directiveTableToolbarCtrl.js